import React from 'react';
import { Hero } from '../components/Hero';
import { WhoAreWe } from '../components/WhoAreWe';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
export function Home() {
  return <PageTransition data-id="element-264">
      <Hero data-id="element-265" />
      <WhoAreWe data-id="element-266" />

      {/* Services Preview */}
      <section className="py-20 bg-brand-light" data-id="element-267">
        <div className="container mx-auto px-4 md:px-6" data-id="element-268">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-269">
            <h2 className="text-4xl font-extrabold text-brand-blue mb-6" data-id="element-270">
              Our Specialized Services
            </h2>
            <p className="text-lg text-gray-600" data-id="element-271">
              We offer a wide range of transportation solutions tailored to meet
              the unique needs of our patients and healthcare partners.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-272">
            {[{
            title: 'Stretcher',
            desc: 'Professional stretcher transport for patients requiring recumbent positioning.'
          }, {
            title: 'Wheelchair',
            desc: 'Safe and comfortable transport for individuals using wheelchairs.'
          }, {
            title: 'Ambulatory',
            desc: 'Reliable door-to-door assistance for patients who can walk but need help.'
          }].map((service, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            duration: 0.5
          }} className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-xl transition-all border border-blue-50 group" data-id="element-273">
                <div className="w-16 h-16 bg-brand-light rounded-2xl mb-6 flex items-center justify-center text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-colors" data-id="element-274">
                  <span className="font-bold text-2xl" data-id="element-275">{service.title[0]}</span>
                </div>
                <h3 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-276">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-277">
                  {service.desc}
                </p>
                <Link to="/services" className="inline-flex items-center gap-2 text-brand-blue font-bold hover:text-blue-700 transition-colors" data-id="element-278">
                  Learn more <ArrowRight size={16} data-id="element-279" />
                </Link>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mt-12" data-id="element-280">
            <Link to="/services" className="inline-flex items-center gap-3 bg-white text-brand-blue border-2 border-brand-blue px-8 py-4 rounded-full font-bold text-lg hover:bg-brand-light transition-all focus-visible:ring-4 focus-visible:ring-blue-400 outline-none" data-id="element-281">
              View All Services
            </Link>
          </motion.div>
        </div>
      </section>
    </PageTransition>;
}